// REACT_APP_ENV is inlined at build time. Unset means dev (local `npm start`, and today's int build,
// which sets nothing). Any other value must be one of the three: a typo such as 'prod' used to fall
// back to dev silently, i.e. a production page selling through the Paddle sandbox.
const KNOWN_ENVS = ['dev', 'int', 'prd'];
const getEnv = () => {
    const raw = process.env.REACT_APP_ENV;
    if (!raw) return 'dev';
    if (!KNOWN_ENVS.includes(raw)) {
        throw new Error(`Unknown REACT_APP_ENV '${raw}': expected one of ${KNOWN_ENVS.join(', ')}.`);
    }
    return raw;
};

const env = getEnv();

const urls = {
    dev: 'https://mailcheck-dev-bsavadc5hbhreyfw.switzerlandnorth-01.azurewebsites.net/api/validate/email/academic',
    int: 'https://mailcheck-int-bsavadc5hbhreyfw.switzerlandnorth-01.azurewebsites.net/api/validate/email/academic',
    prd: 'https://mailcheck-prd-g0fagfg8bbcrexdq.switzerlandnorth-01.azurewebsites.net/api/validate/email/academic',
};

const sellerIds = {
    dev: "38377",
    int: "38377",
    prd: "251597",
};

const hubspotApiUrls = {
    dev: 'https://hubspot-dev-cxembxa3beg5d9aj.switzerlandnorth-01.azurewebsites.net/api',
    int: 'https://hubspot-int-gqf7f9dnhke3g3f4.switzerlandnorth-01.azurewebsites.net/api',
    prd: 'https://hubspot-prd-hafghud5arcdbxa3.switzerlandnorth-01.azurewebsites.net/api',
};

// The middleware is the source of truth for what is sold: it syncs the catalogue to Paddle
// and publishes the active prices (SKU, Paddle price id, cycle, quantity ceiling, list
// amounts) on an anonymous, CORS-open endpoint. The shop renders from that — it holds no
// price id of its own. Override per deployment with REACT_APP_MIDDLEWARE_API_URL.
const middlewareApiUrls = {
    dev: 'https://middleware-api-dev.spherene.io',
    int: 'https://middleware-api-int.spherene.io',
    prd: 'https://middleware-api-prd.spherene.io',
};
const middlewareApiUrl = (process.env.REACT_APP_MIDDLEWARE_API_URL || middlewareApiUrls[env] || middlewareApiUrls.dev).replace(/\/+$/, '');

// Google reCAPTCHA v3 SITE key (public; the page shows it to every visitor). The HubSpot
// function's save-customer-stage requires a token for the action `save_customer_stage`
// (SPHER-3026); its secret half is that Function App's RECAPTCHA_SECRET_KEY. Set per build with
// REACT_APP_RECAPTCHA_SITE_KEY, or put each environment's key here once it exists. Empty: the
// shop sends no token, the function refuses the call, and the checkout carries on without it.
const recaptchaSiteKeys = {
    dev: '',
    int: '',
    prd: '',
};
const recaptchaSiteKey = (process.env.REACT_APP_RECAPTCHA_SITE_KEY || recaptchaSiteKeys[env] || '').trim();

const config = {
    academicEmailValidationUrl: urls[env] || urls.dev,
    hubspotApiUrl: hubspotApiUrls[env] || hubspotApiUrls.dev,
    middlewareApiUrl,
    catalogueUrl: `${middlewareApiUrl}/api/v2.0/catalogue/public`,
    paddleEnv: env === 'prd' ? 'production' : 'sandbox',
    paddleApiKey: process.env.REACT_APP_PADDLE_API_KEY,
    paddleApiUrl: env === 'prd' ? 'https://api.paddle.com' : '/paddle-api', // Use local proxy for sandbox/dev
    paddleSellerId: sellerIds[env], // Optional fallback
    recaptchaSiteKey,
};

export default config;
